import styled from 'styled-components';
import { ClearButton } from '#/shared/components/Styled';
import BaseRefreshIcon from '#/shared/components/GeneratedIcons/generic/Refresh';
import { focusCssRule } from '#/shared/css/focus';

const BaseButton = styled(ClearButton)`
  border-radius: ${props => props.theme.buttonRadius};

  &:focus {
    background-color: transparent;
  }

  @media (any-hover: hover) {
    &:hover {
      background-color: ${props => props.theme.activeColor};
    }
  }
`;

export const TimestampRefreshWrapper = styled.div`
  display: ${props => (props.needsIOSStyles ? 'grid' : 'flex')};
  justify-content: end;
  margin: 6px 2px;
  margin-bottom: inherit;
`;

export const RefreshIcon = styled(BaseRefreshIcon).attrs(props => ({
  fill: props.theme.secondaryColor,
  width: 15,
  height: 15,
}))`
  animation: spin 1s 1 linear;
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const RefreshButton = styled(BaseButton)`
  background-color: transparent;
  color: ${props => props.theme.secondaryColor};
  display: flex;
  align-items: center;
  font-size: 1em;
  margin-left: 5px;
  padding: 5px 10px;

  &:active ${RefreshIcon} {
    animation: none; /* trigger icon animation after button is clicked  */
  }

  ${focusCssRule({ type: 'inset' })}
`;

export const RefreshTime = styled.span`
  padding-left: 6px;
`;
